"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_TYPE = exports.ConsoleLogger = void 0;
var ConsoleLogger_1 = require("./ConsoleLogger");
Object.defineProperty(exports, "ConsoleLogger", { enumerable: true, get: function () { return ConsoleLogger_1.ConsoleLogger; } });
Object.defineProperty(exports, "LOG_TYPE", { enumerable: true, get: function () { return ConsoleLogger_1.LOG_TYPE; } });
